import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BruttoNettoCalculatorModule } from '@metallgehalt/brutto-netto-calculator';

import { BruttoNettoRoutingModule } from './brutto-netto-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, BruttoNettoCalculatorModule, BruttoNettoRoutingModule]
})
export class BruttoNettoModule {}
